export default "__VITE_ASSET__627935e4__"